export enum EUserStatus {
  // User blocked, we don't allow to login
  BLOCKED = 'blocked',
  // User deleted
  DELETED = 'deleted',
  // Initial and default state
  PENDING = 'pending',
  // User pending onboarding steps
  PENDING_EMAIL_VERIFICATION = 'pending_email_verification',
  PENDING_SET_PASSWORD = 'pending_set_password',
  PENDING_MOTIVATION = 'pending_motivation',
  PENDING_SET_PERSONAL_INFO = 'pending_set_personal_info',
  PENDING_SOCIAL_MEDIAS = 'pending_social_medias',
  PENDING_ACCOUNT_ACTIVATION = 'pending_account_activation',
  // User Ready to use the platform
  ACTIVE = 'active',
}
